import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/layout/Layout";
import Home from "../pages/home/page";
import MangaList from "../pages/manga/list";
import MangaDetail from "../pages/manga/detail";
import NewsList from "../pages/news/list";
import NewsDetail from "../pages/news/detail";
import Faq from "../pages/faq/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "manga", element: <MangaList /> },
      { path: "manga/:id", element: <MangaDetail /> },
      { path: "news", element: <NewsList /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "faq", element: <Faq /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;